import type { AnySelfOwnedWidgetClass } from './selfOwnedWidget';
import type { WidgetType } from '@thinkalpha/ui-types/contracts/workspace';
import {
    platformsWidgetDefinition,
    symbolsWidgetDefinition,
    tradersWidgetDefinition,
} from 'src/lib/widget/widgets/aggregated-risk';
import { alphaEyeWidgetDefinition } from 'src/lib/widget/widgets/alpha-eye';
import { notepadWidgetDefinition } from 'src/lib/widget/widgets/notepad';
import { resultsWidgetDefinition } from 'src/lib/widget/widgets/results';
import type { LegacyWidgetViewModel, SelfOwnedWidgetViewModel, WidgetViewModel } from 'src/store/types';

const selfOwnedWidgetDefinitions = [
    alphaEyeWidgetDefinition,
    notepadWidgetDefinition,
    platformsWidgetDefinition,
    resultsWidgetDefinition,
    symbolsWidgetDefinition,
    tradersWidgetDefinition,
] as const;

export const selfOwnedWidgetRegistry: ReadonlyMap<WidgetType, AnySelfOwnedWidgetClass> = new Map<
    WidgetType,
    AnySelfOwnedWidgetClass
>(selfOwnedWidgetDefinitions.map((definition) => [definition.type, definition.widgetClass]));

export function isSelfOwnedWidget(widget: WidgetViewModel): widget is SelfOwnedWidgetViewModel {
    return selfOwnedWidgetRegistry.has(widget.type);
}

export function isLegacyWidget(widget: WidgetViewModel): widget is LegacyWidgetViewModel {
    return !selfOwnedWidgetRegistry.has(widget.type);
}
